import { render, staticRenderFns } from "./Payload.vue?vue&type=template&id=6393075c&scoped=true&"
import script from "./Payload.vue?vue&type=script&lang=js&"
export * from "./Payload.vue?vue&type=script&lang=js&"
import style0 from "./Payload.vue?vue&type=style&index=0&id=6393075c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6393075c",
  null
  
)

export default component.exports